import React from "react";
import Icon from "../Icon";
import { endSlash } from "../../util/helperFunctions";

const ButtonBlock = ({ block }) => {
  return (
    <a
      href={endSlash(block.buttonUrl)}
      target="_blank"
      className="button-block bg-blue b--none w-100 tl flex justify-between items-center pointer white bg-ease-out h-5 ttu mt2 mt3-l"
    >
      {block.buttonTitle}
      <div className="button-block__arrow bg-dark bg-ease-out flex items-center">
        <Icon path="arrow-right" className="flex items-center h-100" />
      </div>
    </a>
  );
};

export default ButtonBlock;



// WEBPACK FOOTER //
// ./src/components/Blocks/ButtonBlock.js